<p style="margin: auto;">redirecting you to patient-esignature-authorization page</p>
